export default __webpack_public_path__ + "static/service4-3087fdec90a3804d7c774d093a49ce69.png";